(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7094],{

/***/ 90902:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/workout/today",
      function () {
        return __webpack_require__(23238);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HV": function() { return /* binding */ fancyTimeFormat; },
/* harmony export */   "oH": function() { return /* binding */ getTimeDataFromSeconds; },
/* harmony export */   "wM": function() { return /* binding */ per; }
/* harmony export */ });
function getTimeDataFromSeconds(seconds) {
    // Hours, minutes and seconds
    var init = {
        hrs: 0,
        mins: 0,
        secs: 0
    };
    if (!seconds) return init;
    init.hrs = ~~(seconds / 3600);
    init.mins = ~~(seconds % 3600 / 60);
    init.secs = ~~seconds % 60;
    return init;
}
function fancyTimeFormat(duration) {
    // Hours, minutes and seconds
    if (!duration) return "0:00";
    var ref = getTimeDataFromSeconds(duration), hrs = ref.hrs, mins = ref.mins, secs = ref.secs;
    // Output like "1:01" or "4:03:59" or "123:03:59"
    var ret = "";
    if (hrs > 0) {
        ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }
    ret += "" + mins + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;
    return ret;
}
function per(num, amount) {
    return num / amount * 100;
}


/***/ }),

/***/ 56262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useWorkout; }
/* harmony export */ });
/* unused harmony export getWorkoutByID */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88767);
/* harmony import */ var _lib_misc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8016);




var getWorkoutByID = function(workoutID) {
    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_lib_misc__WEBPACK_IMPORTED_MODULE_2__/* .fetcher */ ._i)("https://rocky-api.prod.ltdev.io" + "/workouts/" + workoutID, {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    });
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
};
var useWorkout = function(workoutID, initialData) {
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)(workoutID && "workrout/".concat(workoutID), getWorkoutByID(workoutID), {
        initialData: initialData
    }), data = ref.data, dataUpdatedAt = ref.dataUpdatedAt, error = ref.error, errorUpdatedAt = ref.errorUpdatedAt, failureCount = ref.failureCount, isError = ref.isError, isFetched = ref.isFetched, isFetchedAfterMount = ref.isFetchedAfterMount, isFetching = ref.isFetching, isIdle = ref.isIdle, isLoading = ref.isLoading, isLoadingError = ref.isLoadingError, isPlaceholderData = ref.isPlaceholderData, isPreviousData = ref.isPreviousData, isRefetchError = ref.isRefetchError, isRefetching = ref.isRefetching, refetch = ref.refetch, isStale = ref.isStale, isSuccess = ref.isSuccess, status = ref.status;
    return {
        data: data,
        error: error,
        refetch: refetch,
        isLoading: isLoading
    };
};


/***/ }),

/***/ 23238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "getWeekData": function() { return /* binding */ getWeekData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(99534);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63153);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62469);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(86010);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(40364);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(69119);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(77349);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(73959);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(83894);
/* harmony import */ var date_fns_tz__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(70722);
/* harmony import */ var date_fns_tz__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(date_fns_tz__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(72986);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31955);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_cool_inview__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5276);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(74931);
/* harmony import */ var react_rating_stars_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11312);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(43337);
/* harmony import */ var _components_AppLayout__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47239);
/* harmony import */ var _components_avatar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11304);
/* harmony import */ var _components_footer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(23333);
/* harmony import */ var _components_head__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(55480);
/* harmony import */ var _components_workout_helpers__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(59169);
/* harmony import */ var _components_workout_hooks_useWorkout__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(56262);
/* harmony import */ var _helpers_misc__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(56554);
/* harmony import */ var _hooks_useTeams__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(99986);
/* harmony import */ var _lib_captureEvent__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(75507);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(52979);
/* harmony import */ var _lib_identify__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(2823);
/* harmony import */ var _lib_misc__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(8016);
/* harmony import */ var _state_containers_experiment__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(30784);































function Countdown(param) {
    var enabled = param.enabled, _size = param.size, size = _size === void 0 ? "sm" : _size;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0), key = ref[0], setKey = ref[1];
    (0,react_use__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(function() {
        return enabled && setKey(function(n) {
            return n + 1;
        });
    }, 1000);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function() {
        var diff = date_fns__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z(date_fns__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z(date_fns__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z(new Date(), 1)), new Date());
        return (0,_components_workout_helpers__WEBPACK_IMPORTED_MODULE_24__/* .getTimeDataFromSeconds */ .oH)(diff);
    }, [
        key
    ]), hrs = ref1.hrs, mins = ref1.mins, secs = ref1.secs;
    if (!enabled) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "flex space-x-2 text-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "flex items-end",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("-mb-1 tracking-widest center font-druk", {
                            "text-2xl": size === "sm",
                            "text-4xl": size === "lg"
                        }),
                        children: hrs
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        className: "text-xs",
                        children: "HR"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "flex items-end",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("-mb-1 tracking-widest center font-druk", {
                            "text-2xl": size === "sm",
                            "text-4xl": size === "lg"
                        }),
                        children: mins
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        className: "text-xs",
                        children: "MIN"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "flex items-end",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("-mb-1 tracking-widest center font-druk", {
                            "text-2xl": size === "sm",
                            "text-4xl": size === "lg"
                        }),
                        children: secs
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        className: "text-xs",
                        children: "SEC"
                    })
                ]
            })
        ]
    });
}
var PlaylistItem = function(param) {
    var data = param.data, activeIndex = param.activeIndex, ndx = param.ndx;
    var name = data.name, duration = data.duration, movementThumbnailUrl = data.movementThumbnailUrl, thumbnailUrl = data.thumbnailUrl, audioUrl = data.audioUrl, muxAudioUrl = data.muxAudioUrl, reps = data.reps;
    var img = movementThumbnailUrl || thumbnailUrl;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("flex relative justify-between w-full px-2 py-2 pr-2 text-left rounded-r-lg md:px-6 no-highlight"),
        children: [
            activeIndex === ndx ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "absolute top-0 bottom-0 left-0 w-1 h-full rounded bg-lemon"
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "flex items-center pr-4 space-x-4",
                children: [
                    img ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                        className: "self-start w-12 h-12 rounded-md 2xl:w-16 2xl:h-16",
                        src: (movementThumbnailUrl || thumbnailUrl || "/assets/logo/white-icon.svg") + "?w=80"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "rounded-md bg-neutral-900",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                            className: "self-start w-12 h-12 p-3 2xl:w-16 2xl:h-16",
                            src: "/assets/logo/white-icon.svg"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("opacity-90", {
                                    "font-bold": activeIndex === ndx,
                                    "font-medium": activeIndex !== ndx
                                }),
                                children: name
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "flex items-center space-x-2 text-sm opacity-70",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        children: (0,_components_workout_helpers__WEBPACK_IMPORTED_MODULE_24__/* .fancyTimeFormat */ .HV)(duration)
                                    }),
                                    audioUrl || muxAudioUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_2__/* .VolumeUpIcon */ .MCl, {
                                        className: "w-3 h-3 text-white"
                                    }) : null,
                                    reps ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        className: "opacity-60",
                                        children: "".concat(reps, " reps")
                                    }) : null
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var Playlist = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "py-4",
        children: (0,_helpers_misc__WEBPACK_IMPORTED_MODULE_14__/* .limit */ .b9)(data, 8).map(function(_param, ndx) {
            var type = _param.type, movement = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(_param, [
                "type"
            ]);
            return type !== "section" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PlaylistItem, {
                data: movement,
                activeIndex: 0,
                ndx: ndx
            }, movement.id) : null;
        })
    });
};
var Card = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_6__.memo(function(param) {
    var workout = param.workout, teamID = param.teamID, countdown = param.countdown;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var data = (0,_components_workout_hooks_useWorkout__WEBPACK_IMPORTED_MODULE_13__/* .useWorkout */ .U)(workout.id).data;
    var ref8 = (0,_hooks_useTeams__WEBPACK_IMPORTED_MODULE_15__/* .useTeams */ .y2)(teamID), team = ref8.activeTeam;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "rounded-2xl shadow-xl max-w-md mx-auto border border-[#7D7C7D]/20 p-5 bg-[#232323]/80 backdrop-blur-md",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                style: {
                    backgroundImage: "url('".concat(workout.posterImgixUrl + "?w=300", "')")
                },
                className: "h-[26rem] sm:h-[32rem] flex flex-col shadow-md bg-center items-start justify-between w-full relative bg-cover rounded-xl overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "absolute inset-x-0 top-0 h-3/5 bg-gradient-to-b from-black/60 to-transparent"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "absolute inset-x-0 bottom-0 h-3/5 bg-gradient-to-t from-black/90 to-transparent"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "flex items-center justify-between px-4 pt-4",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "relative flex items-center gap-2",
                            children: [
                                team === null || team === void 0 ? void 0 : (ref = team.coaches) === null || ref === void 0 ? void 0 : (ref1 = ref.map) === null || ref1 === void 0 ? void 0 : ref1.call(ref, function(param, i) {
                                    var profileImg = param.profileImg;
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_avatar__WEBPACK_IMPORTED_MODULE_10__/* .Avatar */ .q, {
                                        src: profileImg,
                                        variant: _components_avatar__WEBPACK_IMPORTED_MODULE_10__/* .Avatar.variant.Circle */ .q.variant.Circle,
                                        size: _components_avatar__WEBPACK_IMPORTED_MODULE_10__/* .Avatar.size.XS */ .q.size.XS,
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({
                                            "absolute -ml-10 shadow rounded-full": i > 0
                                        })
                                    }, i);
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "flex flex-col justify-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h4", {
                                            className: "text-lg font-medium leading-none",
                                            children: (team === null || team === void 0 ? void 0 : team.name) || "..."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "flex gap-1 text-sm",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                    className: "",
                                                    children: "Coach"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                    children: team === null || team === void 0 ? void 0 : (ref2 = team.coaches) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.map) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.call(ref2, function(param, i) {
                                                        var givenName = param.givenName, profileImg = param.profileImg;
                                                        return givenName;
                                                    })) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.join) === null || ref5 === void 0 ? void 0 : ref5.call(ref4, ", ")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "relative flex p-4 space-x-2 divide-x divide-white",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                        className: "text-xl font-bold",
                                        children: (data === null || data === void 0 ? void 0 : data.duration) ? date_fns__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z(data.duration) : "..."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        className: "text-sm",
                                        children: "Min"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "pl-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                                        className: "text-xl font-bold",
                                        children: workout.name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "flex items-center space-x-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                className: "text-sm",
                                                children: workout.type
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_rating_stars_component__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                count: 5,
                                                value: Number(data === null || data === void 0 ? void 0 : (ref6 = data.rating) === null || ref6 === void 0 ? void 0 : ref6.avg),
                                                edit: false,
                                                size: 12,
                                                activeColor: "#E6FF00"
                                            }, data === null || data === void 0 ? void 0 : (ref7 = data.rating) === null || ref7 === void 0 ? void 0 : ref7.avg)
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "pt-4",
                children: [
                    countdown ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "flex items-end justify-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h4", {
                                className: "text-base font-bold text-transparent bg-white bg-clip-text",
                                children: "ENDS IN"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Countdown, {
                                enabled: countdown
                            })
                        ]
                    }) : null,
                    (data === null || data === void 0 ? void 0 : data.playlist) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Playlist, {
                        data: data === null || data === void 0 ? void 0 : data.playlist
                    }) : null
                ]
            })
        ]
    });
});
function Loading() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_28__/* .motion.div */ .E.div, {
        className: "h-screen text-white bg-black center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
            className: "",
            src: "/assets/logo/white.svg",
            alt: "Ladder Logo",
            width: 632 * 0.15,
            height: 104 * 0.15
        })
    });
}
var LoadingSpinner = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
        className: "w-6 h-6 text-black animate-spin",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
        ]
    });
};
var CTAEmailSection = function(param) {
    var handleSubmitCTA = param.handleSubmitCTA, loading = param.loading, value = param.value, setValue = param.setValue, handleKeyDown = param.handleKeyDown, handleSubmit = param.handleSubmit, fromEmail = param.fromEmail;
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().query;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("relative center", {
            "px-6 py-4 border rounded-full border-white/60": !fromEmail
        }),
        children: fromEmail ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
            onClick: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return handleSubmitCTA();
                        case 2:
                            return _ctx.abrupt("return", _ctx.sent);
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            })),
            className: "w-full px-4 py-3 mx-auto text-sm text-black rounded-full md:max-w-md center right-2 inset-y-2 bg-volt cta lg:text-base",
            children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LoadingSpinner, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                children: "START YOUR WORKOUT"
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                    autoFocus: true,
                    value: value,
                    placeholder: "Enter Your Email",
                    name: "email",
                    type: "email",
                    onChange: function(event) {
                        return setValue(event.target.value);
                    },
                    onKeyDown: handleKeyDown,
                    className: "relative w-full pr-24 mx-auto text-base text-left text-white bg-transparent outline-none lg:pr-32 focus:shadow-none ring-transparent focus:ring-transparent focus:outline-none flex-center"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                    onClick: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    _ctx.next = 2;
                                    return handleSubmit(value);
                                case 2:
                                    return _ctx.abrupt("return", _ctx.sent);
                                case 3:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    })),
                    className: "absolute px-4 py-2 text-sm text-black rounded-full center right-2 inset-y-2 bg-volt cta lg:text-base",
                    children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LoadingSpinner, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        children: " GET FREE WORKOUTS"
                    })
                })
            ]
        })
    });
};
function Page(param) {
    var workout = param.workout, yWorkout = param.yWorkout, tWorkout = param.tWorkout, teamID = param.teamID, error = param.error;
    var _obj, ref;
    var ref1 = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)(), push = ref1.push, query = ref1.query, isReady = ref1.isReady;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""), value = ref2[0], setValue = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react_cool_inview__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)({}), observe = ref4.observe, inView = ref4.inView;
    var fromEmail = query.utm_source === "email" || query.from === "email";
    var isDisabled = !value.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i);
    var handleSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(value) {
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isDisabled) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        react_hot_toast__WEBPACK_IMPORTED_MODULE_30__/* ["default"].custom */ .ZP.custom(function(t) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "".concat(t.visible ? "animate-enter" : "animate-leave", " max-w-md w-full bg-neutral-800 shadow-lg rounded-lg pointer-events-auto flex border border-neutral-700"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "justify-start flex-1 w-0 p-4 center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "flex items-start",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "flex-shrink-0 pt-0.5",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_3__/* .CheckCircledIcon */ .NhS, {
                                                    className: "w-6 h-6 text-volt"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "flex-1 ml-3",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                    className: "text-sm font-medium text-neutral-100",
                                                    children: "Success! You will receive Daily Workouts from Ladder in your email"
                                                })
                                            })
                                        ]
                                    })
                                })
                            });
                        }, {
                            position: "top-center",
                            duration: 3000,
                            id: "email-capture"
                        });
                        setLoading(true);
                        (0,_lib_identify__WEBPACK_IMPORTED_MODULE_31__/* .identify */ .y)({
                            email: value
                        });
                        (0,_lib_captureEvent__WEBPACK_IMPORTED_MODULE_16__/* .captureEvent */ .e)({
                            category: "todays_workout",
                            action: "Today_WO_Email_Captured",
                            label: "Email Capture",
                            value: value
                        });
                        js_cookie__WEBPACK_IMPORTED_MODULE_4__/* ["default"].set */ .Z.set(_lib_constants__WEBPACK_IMPORTED_MODULE_17__/* .WO_EMAIL_CAPTURE_COOKIE_NAME */ .LW, value);
                        _ctx.next = 9;
                        return push((0,_lib_misc__WEBPACK_IMPORTED_MODULE_18__/* .getUrlWithUtms */ .uD)(new URL("".concat("https://joinladder.com", "/workout?workoutId=").concat(workout.id))));
                    case 9:
                        setLoading(false);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmitCTA = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        (0,_lib_captureEvent__WEBPACK_IMPORTED_MODULE_16__/* .captureEvent */ .e)({
                            category: "todays_workout",
                            action: "Today_WO_CTA_Clicked",
                            label: "CTA Clicked"
                        });
                        _ctx.next = 4;
                        return push((0,_lib_misc__WEBPACK_IMPORTED_MODULE_18__/* .getUrlWithUtms */ .uD)(new URL("".concat("https://joinladder.com", "/workout?workoutId=").concat(workout.id, "&hideEmailCapture=1"))));
                    case 4:
                        setLoading(false);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmitCTA() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleKeyDown = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var key;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        key = param.key;
                        if (!isDisabled) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        if (!(key === "Enter")) {
                            _ctx.next = 7;
                            break;
                        }
                        _ctx.next = 6;
                        return handleSubmit(value);
                    case 6:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleKeyDown(_) {
            return _ref.apply(this, arguments);
        };
    }();
    if (!workout || !isReady) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Loading, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_head__WEBPACK_IMPORTED_MODULE_12__/* .HeadContent */ .Q, {
                title: "Ladder | Workout of the Day"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_hot_toast__WEBPACK_IMPORTED_MODULE_30__/* .Toaster */ .x7, {
                position: "top-center",
                toastOptions: {
                    // Define default options
                    className: "",
                    duration: 5000
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "w-full max-w-full min-h-screen overflow-hidden text-white",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "container flex-col px-2 pt-6 pb-4 mx-auto text-center lg:py-6 center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                className: "self-start",
                                href: (0,_lib_misc__WEBPACK_IMPORTED_MODULE_18__/* .getUrlWithUtms */ .uD)(new URL("https://joinladder.com")),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                    className: "lg:w-[8rem] w-[8rem] px-2",
                                    src: "/assets/logo/white.svg",
                                    alt: "Ladder Logo"
                                })
                            }),
                            fromEmail ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h3", {
                                        className: "mt-6 text-xl tracking-tight lg:mt-8 lg:tracking-normal lg:text-3xl",
                                        children: [
                                            "LADDER'S ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                className: "text-volt",
                                                children: "FREE"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                                        className: "text-3xl tracking-tight lg:mt-1 lg:tracking-normal lg:text-5xl heading",
                                        children: "WORKOUT OF THE DAY"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        className: "max-w-xl px-2 mt-4 mb-2 text-sm text-center lg:px-12 lg:mt-5 lg:text-base opacity-60",
                                        children: "Today's Workout Ends In"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "center opacity-90",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Countdown, {
                                            enabled: !loading,
                                            size: "lg"
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h3", {
                                        className: "mt-6 text-xl tracking-tight lg:mt-8 lg:tracking-normal lg:text-3xl",
                                        children: [
                                            "GET LADDER'S ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                className: "text-volt",
                                                children: "FREE"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                                        className: "text-3xl tracking-tight lg:mt-1 lg:tracking-normal lg:text-5xl heading",
                                        children: "WORKOUT OF THE DAY"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                                        className: "text-xl tracking-tight lg:mt-1 lg:tracking-normal lg:text-3xl",
                                        children: "IN YOUR INBOX, EVERY MORNING"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        className: "max-w-xl px-2 mt-4 text-sm text-center lg:px-12 lg:mt-5 lg:text-base opacity-60",
                                        children: "Get a free strength and conditioning workout every day. Used by 40k+ people to get stronger, mentally and physically."
                                    })
                                ]
                            }),
                            !fromEmail ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                ref: observe,
                                className: "w-full max-w-xl px-2 mx-auto mt-6",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CTAEmailSection, {
                                    handleSubmitCTA: handleSubmitCTA,
                                    loading: loading,
                                    value: value,
                                    setValue: setValue,
                                    handleKeyDown: handleKeyDown,
                                    handleSubmit: handleSubmit,
                                    fromEmail: fromEmail,
                                    hideFromEmail: true
                                })
                            }) : null,
                            !fromEmail ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "relative flex mt-6 mb-2 space-x-2 center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "relative flex -space-x-3",
                                        children: (ref = (_obj = [
                                            1,
                                            2,
                                            3,
                                            4
                                        ]).map) === null || ref === void 0 ? void 0 : ref.call(_obj, function(img, i) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_avatar__WEBPACK_IMPORTED_MODULE_10__/* .Avatar */ .q, {
                                                src: "/assets/avatars/".concat(img, ".png"),
                                                variant: _components_avatar__WEBPACK_IMPORTED_MODULE_10__/* .Avatar.variant.Circle */ .q.variant.Circle,
                                                size: _components_avatar__WEBPACK_IMPORTED_MODULE_10__/* .Avatar.size.XS */ .q.size.XS,
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({
                                                    "transform shadow rounded-full": i > 0
                                                })
                                            }, i);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                        className: "flex text-sm text-white/70",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("b", {
                                                className: "mr-1 font-bold text-volt",
                                                children: "466,904"
                                            }),
                                            " workouts completed"
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "relative mb-12",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_28__/* .motion.div */ .E.div, {
                                initial: {
                                    x: 0,
                                    y: 0,
                                    opacity: 0
                                },
                                animate: {
                                    x: 250,
                                    y: 48,
                                    opacity: 0.5
                                },
                                transition: {
                                    delay: 0.3
                                },
                                className: "absolute inset-0 blur-[6px]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Card, {
                                    workout: yWorkout || workout,
                                    teamID: teamID
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_28__/* .motion.div */ .E.div, {
                                initial: {
                                    x: 0,
                                    y: 0,
                                    opacity: 0
                                },
                                animate: {
                                    x: -250,
                                    y: 48,
                                    opacity: 0.5
                                },
                                transition: {
                                    delay: 0.3
                                },
                                className: "absolute inset-0 blur-[6px]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Card, {
                                    workout: tWorkout || workout,
                                    teamID: teamID
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "px-6 lg:px-0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Card, {
                                    workout: workout,
                                    teamID: teamID,
                                    countdown: !fromEmail || !loading
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_28__/* .motion.div */ .E.div, {
                        initial: fromEmail ? "inView" : "outView",
                        animate: !inView || fromEmail ? "inView" : "outView",
                        variants: {
                            inView: {
                                opacity: 1
                            },
                            outView: {
                                opacity: 0
                            }
                        },
                        style: {
                            background: "linear-gradient(180deg, rgba(14, 14, 14, 0) 0%, #0E0E0E 34.27%)"
                        },
                        className: "fixed z-10 inset-x-0 bottom-0 h-[10rem] lg:h-[12rem] bg-gradient-to-t from-black to-transparent"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_28__/* .motion.div */ .E.div, {
                        initial: fromEmail ? "inView" : "outView",
                        animate: !inView || fromEmail ? "inView" : "outView",
                        variants: {
                            inView: {
                                y: 0
                            },
                            outView: {
                                y: 120
                            }
                        },
                        className: "fixed inset-x-0 bottom-0 z-10 w-full max-w-xl px-4 py-4 mx-auto lg:py-8",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CTAEmailSection, {
                            handleSubmitCTA: handleSubmitCTA,
                            loading: loading,
                            value: value,
                            setValue: setValue,
                            handleKeyDown: handleKeyDown,
                            handleSubmit: handleSubmit,
                            fromEmail: fromEmail
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_footer__WEBPACK_IMPORTED_MODULE_11__/* .Footer */ .$, {})
        ]
    });
}
var PageWrapper = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_state_containers_experiment__WEBPACK_IMPORTED_MODULE_19__/* .ExperimentProvider */ .I, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Page, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)({}, props))
    });
};
var __N_SSG = true;
var getWeekData = function() {
    var startDate = date_fns_tz__WEBPACK_IMPORTED_MODULE_33__.format(date_fns__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z(new Date()), "yyyy-MM-dd", {
        timeZone: "America/Chicago"
    });
    var endDate = date_fns_tz__WEBPACK_IMPORTED_MODULE_33__.format(date_fns__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z(new Date()), "yyyy-MM-dd", {
        timeZone: "America/Chicago"
    });
    return {
        startDate: startDate,
        endDate: endDate
    };
};
PageWrapper.Layout = _components_AppLayout__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z;
/* harmony default export */ __webpack_exports__["default"] = (PageWrapper);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,7409,6308,1664,3041,5980,6727,1653,1209,1693,7615,4401,7792,7239,9774,2888,179], function() { return __webpack_exec__(90902); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);